class MMXPasswordCountdown extends HTMLElement {
  connectedCallback() {
    const endDate = this.dataset.endDate;
    if (!endDate) return;

    const end = new Date(endDate).getTime();
    if (Number.isNaN(end)) return;

    const daysEl = this.querySelector('[data-days]');
    const hoursEl = this.querySelector('[data-hours]');
    const minutesEl = this.querySelector('[data-minutes]');
    const secondsEl = this.querySelector('[data-seconds]');

    if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

    const update = () => {
      let diff = Math.max(0, end - Date.now());

      const days = Math.floor(diff / 86400000);
      diff -= days * 86400000;
      const hours = Math.floor(diff / 3600000);
      diff -= hours * 3600000;
      const minutes = Math.floor(diff / 60000);
      diff -= minutes * 60000;
      const seconds = Math.floor(diff / 1000);

      daysEl.textContent = String(days).padStart(2, '0');
      hoursEl.textContent = String(hours).padStart(2, '0');
      minutesEl.textContent = String(minutes).padStart(2, '0');
      secondsEl.textContent = String(seconds).padStart(2, '0');
    };

    update();
    this._interval = setInterval(update, 1000);
  }

  disconnectedCallback() {
    if (this._interval) clearInterval(this._interval);
  }
}

if (!customElements.get('mmx-password-countdown')) {
  customElements.define('mmx-password-countdown', MMXPasswordCountdown);
}
